import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { filterCommonAttributes } from '../ai-answer-dialog/analytics-helpers';
import type { commonAttributesType } from '../ai-answer-dialog/types';

/**
 * Variant of the Person knowledge card the loaded event was fired from.
 * - `singlePerson` — the rich `UserProfilePreview` Relay-backed card.
 * - `multiPerson` — the `UserInlinePreviewList` shown when the search resolves to multiple people.
 */
export type PersonKnowledgeCardVariant = 'singlePerson' | 'multiPerson';

interface PersonKnowledgeCardLoadedProps extends commonAttributesType {
	personCardVariant: PersonKnowledgeCardVariant;
	/** Optional wall-clock load time in ms. */
	loadTime?: number;
}

export const onPersonKnowledgeCardLoaded = (
	props: PersonKnowledgeCardLoadedProps,
): AnalyticsEventPayload => {
	const { source, personCardVariant, loadTime } = props;
	return {
		action: 'loaded',
		actionSubject: 'aiAnswerPersonKnowledgeCard',
		source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			personCardVariant,
			loadTime,
		},
	};
};
